var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFilledTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.977,
    height: 5.002,
    viewBox: "0 0 7.977 5.002"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.319 3.142l2.88-2.82a1.13 1.13 0 011.58 0l2.88 2.82a1.09 1.09 0 01-.79 1.86h-5.76a1.09 1.09 0 01-.79-1.86z"
  })));
}
export default SvgArrowFilledTop;